import { useAppDispatch } from "../hooks";
import { ICategory } from "../interfaces/category.interface";
import { IProject } from "../interfaces/project.interface";
import { createProjectCsv } from "../services/firestore.service";
import { dismiss } from "../slices/dialogsSlice";

interface DownloadCsvDialogProps {
    project: IProject;
    categories: ICategory[];
    dialogId: number;
}

export const DownloadCsvDialog = ({ project, categories, dialogId }: DownloadCsvDialogProps) => {
    const dispatch = useAppDispatch();

    const doDownload = (e) => {
        e.preventDefault();

        let data = new FormData(e.target);

        let startTimestamp = Date.parse(data.get("start-date").toString());
        let endTimestamp = Date.parse(data.get("end-date").toString());

        let startDate = isNaN(startTimestamp) ? null : new Date(startTimestamp);
        let endDate = isNaN(endTimestamp) ? null : new Date(endTimestamp);

        if (!!endDate) endDate.setDate(endDate.getDate() + 1);

        createProjectCsv(project, categories, startDate, endDate).then(() => {
            close();
        });
    };

    const close = () => {
        dispatch(dismiss(dialogId));
    };

    return (
        <>
            <h1>Download a csv</h1>

            <p>
                Note this will not include any unfinshed entries, and only include entries fully
                within in the specified period.
            </p>

            <form onSubmit={doDownload}>
                <input name="start-date" placeholder="Start" type="date" />
                <input name="end-date" placeholder="end" type="date" />

                <button type="submit">Download</button>
            </form>

            <button className="warn" onClick={close}>
                Cancel
            </button>
        </>
    );
};
